import { render, staticRenderFns } from "./MenuPos.vue?vue&type=template&id=661ad348&scoped=true&"
import script from "./MenuPos.vue?vue&type=script&lang=js&"
export * from "./MenuPos.vue?vue&type=script&lang=js&"
import style0 from "./MenuPos.vue?vue&type=style&index=0&id=661ad348&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ad348",
  null
  
)

export default component.exports